export default class HouseAdSelectionStrategy {}
HouseAdSelectionStrategy.First = 'first';
HouseAdSelectionStrategy.Random = 'random';
